/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type RequestWorkEntityFieldQueryVariables = Types.Exact<{
    correlationId: Types.Scalars['String'];
}>;

export type RequestWorkEntityFieldQuery = {
    __typename: 'Query';
    requestWorkEntity: Types.Maybe<{
        __typename: 'WorkEntity';
        workName: string;
        views: Array<
            Types.Maybe<{
                __typename: 'View';
                height: Types.Maybe<number>;
                width: number;
                name: string;
                sceneType: string;
                _links: {
                    __typename: 'ViewLink';
                    image: { __typename: 'ViewLinkImage'; href: string; title: string };
                };
            }>
        >;
    }>;
};

export const RequestWorkEntityFieldDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'RequestWorkEntityField' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'correlationId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestWorkEntity' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'correlationId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'correlationId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'workName' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'views' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'input' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'purpose' },
                                                        value: {
                                                            kind: 'StringValue',
                                                            value: 'design.studio.review',
                                                            block: false,
                                                        },
                                                    },
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'width' },
                                                        value: { kind: 'IntValue', value: '640' },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'height' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'width' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sceneType' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '_links' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'image' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'href',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'title',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useRequestWorkEntityFieldQuery__
 *
 * To run a query within a React component, call `useRequestWorkEntityFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestWorkEntityFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestWorkEntityFieldQuery({
 *   variables: {
 *      correlationId: // value for 'correlationId'
 *   },
 * });
 */
export function useRequestWorkEntityFieldQuery(
    baseOptions: Apollo.QueryHookOptions<
        RequestWorkEntityFieldQuery,
        RequestWorkEntityFieldQueryVariables
    >
) {
    return Apollo.useQuery<RequestWorkEntityFieldQuery, RequestWorkEntityFieldQueryVariables>(
        RequestWorkEntityFieldDocument,
        baseOptions
    );
}
export function useRequestWorkEntityFieldLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        RequestWorkEntityFieldQuery,
        RequestWorkEntityFieldQueryVariables
    >
) {
    return Apollo.useLazyQuery<RequestWorkEntityFieldQuery, RequestWorkEntityFieldQueryVariables>(
        RequestWorkEntityFieldDocument,
        baseOptions
    );
}
export type RequestWorkEntityFieldQueryHookResult = ReturnType<
    typeof useRequestWorkEntityFieldQuery
>;
export type RequestWorkEntityFieldLazyQueryHookResult = ReturnType<
    typeof useRequestWorkEntityFieldLazyQuery
>;
export type RequestWorkEntityFieldQueryResult = Apollo.QueryResult<
    RequestWorkEntityFieldQuery,
    RequestWorkEntityFieldQueryVariables
>;
